import { render, staticRenderFns } from "./RsaPazientePaiPage.vue?vue&type=template&id=05edad72"
import script from "./RsaPazientePaiPage.vue?vue&type=script&lang=js"
export * from "./RsaPazientePaiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports